
























































































import Vue from 'vue'
import Component from 'vue-class-component';
import {State} from 'vuex-class';
import UserGroup from '@/modules/user/model/UserGroup';
import GroupReleaseAssignation from '../model/GroupReleaseAssignation';
import AppReleaseSelect from '@/modules/app-router/components/AppRelease/AppReleaseSelect.vue'
import App from '@/modules/app-router/model/App'
import {loadModule} from '@/store'
import {MutationTypes} from '@/modules/app-router/store/mutations'
import UserPlaformStatusChange from '../model/UserPlaformStatusChange';
import * as api from '@/modules/app-router/api'
import _ from 'lodash'
import AppRelease from '../model/AppRelease';
import apiUnigestService from '@/modules/core/ApiUnigestService'; //'../../core/apiService'; 
import { Colors, notify } from '@/modules/core/notification';

/**
 * Widget cargado en la pantalla de usuario para mostrar información sobre el grupo
 */
@Component({
    components: {AppReleaseSelect},
})
export default class UserGroupWidget extends Vue {
    
    public serverSqlList =  new Array<ServerSQl>();   //public serverSQLCurrent = ['','DATOS','NGLOBA-DATA2','CSWS2','NGLOBA-DATA3','NEOSRV2','LOCALHOST\\SQLEXPRESS'];

    /**
     * Grupo de usuarios seleccionado
     */
    @State(state => state.user.userGroup)
    public group: UserGroup

    /**
     * Aplicación actualmente seleccionada por el usuario
     */
    @State(state => (state.appRouter && state.appRouter.app) ? state.appRouter.app : null )
    public app: App

    /**
     * Lista de asignaciones de distribuciones a grupos de
     * usuarios
     *
     * @var { GroupReleaseAssignation[] }
     */
    @State(state => (state.appRouter && state.appRouter.groupReleaseAssignations) ? state.appRouter.groupReleaseAssignations : null)
    public assignations: GroupReleaseAssignation[]

    /**
     * Lista de asignaciones de distribuciones a grupos de
     * usuarios
     *
     * @var { GroupReleaseAssignation }
     */
    @State(state => (state.appRouter && state.appRouter.groupReleaseAssignation) ? state.appRouter.groupReleaseAssignation : null) // @State(state => state.appRouter.groupReleaseAssignation)
    public assignation: GroupReleaseAssignation
   
    public loading = true
    public deleteUserPlaformConfirm = false
    public deleting = false
    public isIni = true
    public idGroupOld = 0
    public isDeleteFromBBDDUnigest = false
    public isReleaseParent = false;
    // private unsubscribeDeleteUserGroup: any
    private nameTaksDeleteUserGroupPlaforn =
    "TaksDeleteUserPlaforn" + new Date().getTime();
    public releaseCurrent: any;
    /**
     * Al crear el componente carga la lista de asignaciones
     */
    public async created () {
        
        //this.serverSQLCurrent = ['','DATOS','NGLOBA-DATA2','CSWS2','NGLOBA-DATA3','NEOSRV2','LOCALHOST\\SQLEXPRESS'];
        this.serverSqlList.push(new ServerSQl("Según configuración de Unigest",''));
        this.serverSqlList.push(new ServerSQl("DATA1",'NGLOBA-DATA1'));
        this.serverSqlList.push(new ServerSQl("DATA2",'NGLOBA-DATA2'));
        this.serverSqlList.push(new ServerSQl("DATA3",'NGLOBA-DATA3'));
        this.serverSqlList.push(new ServerSQl("DATA4",'NGLOBA-DATA4'));
        this.serverSqlList.push(new ServerSQl("CWS2",'CWS2'));
        this.serverSqlList.push(new ServerSQl("NEOSRV2",'NEOSRV2'));
        this.serverSqlList.push(new ServerSQl("LOCALHOST",'LOCALHOST\\SQLEXPRESS')); 
        
        // cargar el modulo appRouter
        await loadModule('appRouter')
        
        // Carga la lista de usuarios
        await this.$store.dispatch('appRouter/loadApps')
        await this.$store.dispatch('appRouter/loadApis')

        // Obtener la aplicacion (Unigest.net) del local store (cache)
        let selectedApp = JSON.parse(localStorage.getItem('appRouter.selectedApp') || 'null')
        // Si no hay en el local store se asigna por defecto la 1 (id 1) que es unigest.net el primer registro de la tabla app 
        if (!selectedApp) {
            selectedApp = 1;
        }
        // Asignar y activar el registro 1 de las
        await this.$store.dispatch('appRouter/loadApp', selectedApp)

        const api = this.$store.state.appRouter.apis[0] 
        if (!api) {
            return
        }
        this.$store.commit('appRouter/SET_CURRENT_API', api)
        // Cargar la versiones
        await this.$store.dispatch('appRouter/loadGroupReleaseAssignations')
        
        // Asignar/mostrar la version enrutada que tiene asingado el grupo
        this.releaseCurrent = this.assignReleaseToGroupCurrent()

        /* this.unsubscribeDeleteUserGroup = this.$store.subscribeAction((action, state) => {
            if((action.type === 'user/beforeDeleteUserGroup')) {
                this.isDeleteFromBBDDUnigest = state.user.checkingiDeleteFromBBDDUnigest
                if(this.isDeleteFromBBDDUnigest) {
                    this.onDeletePlatformUser() // this.deleteUserPlaformConfirm = true //
                }
            }
        }) */

        this.$store.commit("user/SET_TASK_BEFORE_DELETE_USER_GROUP", {
            name: this.nameTaksDeleteUserGroupPlaforn,
            task: this.taskDeletePlatformUserGroup,
        });

        this.setServerDefault();
        this.busy = false
    }

    destroyed () {
        /* // desuscripbirse de la accion user/deleteUser
        if(this.unsubscribeDeleteUserGroup){
            this.unsubscribeDeleteUserGroup()
        } */
        this.setGroupReleaseAssignatione(null)
        // borrar tarea
        this.$store.commit("user/DELETE_TASK_BEFORE_DELETE_USER_GROUP", {
            name: this.nameTaksDeleteUserGroupPlaforn,
        });
    }

    beforeUpdate() {
       const group = this.$store.state.user.userGroup;
       if(this.idGroupOld === group.id){
           return
       }
      this.releaseCurrent = this.assignReleaseToGroupCurrent()
    }
    
    
    public taskDeletePlatformUserGroup = async () => {
      if (!this.$store.state.user.checkingiDeleteFromBBDDUnigest) {
        return;
      }
      this.isDeleteFromBBDDUnigest = true
      await this.deleteAllUsersFromPlatform()
    }
    /**
     * Actualiza un campo de del grupo actualmente seleccionado
     *
     * @param field
     * @param value
     */
    public updateField (field: string, value: any) {
        this.$store.commit('user/UPDATE_USER_GROUP_FIELD', {field, value})
    }
    
    /**
     * Actualiza un campo de del grupo actualmente seleccionado
     *
     * @param field
     * @param value
     */
    public updateFieldRelease (field: string, value: any) {
        const id = value.id
        this.$store.commit('user/UPDATE_USER_GROUP_FIELD', {field, id})
        this.isReleaseParent = false;
    }

    public setGroupReleaseAssignatione (value: any) {
          this.$store.commit(`appRouter/${MutationTypes.SetGroupReleaseAssignation}`, new GroupReleaseAssignation(value,this.group))
    }

    public onDeletePlatformUser() {
        this.deleting = true
        this.deleteAllUsersFromPlatform()
        this.deleteUserPlaformConfirm = false
        this.deleting = false
    }
    private async deleteAllUsersFromPlatform() {    
        if(this.busy) return
        try {
            this.$emit('loading', this.busy = true) //this.loading = true 
            const data = this.dataToUserPlaformDelete();
            const result =  await api.ChangeUserStatusPlatform(data)
            return result
        } catch (e) {
            // Si hay un error 
            throw new Error(_.get(e, 'response.data.message', e.message))
        } finally {
            this.$emit('loading', (this.busy = false)) //this.loading = false
        }
    }

    /***
     * Asignar/mostrar en le selector la version enrutada que tiene asingado el grupo
     * Permite obtener la distribución configurar para el grupo argumentado
     */
    private assignReleaseToGroupCurrent() {
        const group = this.$store.state.user.userGroup;
        this.idGroupOld = group.id
        this.isReleaseParent = true;
        // Obtener version asignado al grupo actual.
        let assignation = this.assignations.find(a => a.group.id === group.id)

        // Si no tiene asignado una version el grupo actual, comprobamos si tiene el grupo padre,
        if(!assignation &&  group.parent){
            // si tiene grupo padre comprobamos si el padre tiene una vesion asignado, si tiene, entonces mostramos el del padre.
            assignation = this.assignations.find(a => a.group.id === group.parent.id)
        } else {
            this.isReleaseParent = false;
        }
        
        if (!assignation) {
            this.isReleaseParent = false;
            return
        } 
        let release = (assignation && assignation.release) ? assignation.release : new AppRelease();
        this.$store.commit(`appRouter/${MutationTypes.SetGroupReleaseAssignation}`, new GroupReleaseAssignation(release,this.group))
        return release
    }

    private dataToUserPlaformDelete(): UserPlaformStatusChange {
        const data = new UserPlaformStatusChange()
        data.id = this.group.id
        data.serialOrEmail = this.group.attributes.SERIAL_NUMBER || ''
        data.scopeAffected = 2 // ambito borrar por nº de serie
        data.userStatus = 2 // Borrado de la plataforma
        data.borradoTotal = true
        data.apiUrl = ''
        return data
    }
    public get isGroupParent(): boolean {
        return (this.group.children && this.group.children.length > 0)
    }

    public get uriApi():string{
        /* if(this.releaseCurrent && this.releaseCurrent.apiVersion && this.releaseCurrent.apiVersion.uri)
            return this.releaseCurrent.apiVersion.uri;
        else
            return  ''; */
        
        if(this.assignation && this.assignation.release && this.assignation.release.apiVersion &&  this.assignation.release.apiVersion.uri)
            return this.assignation.release.apiVersion.uri ;
        else
            return  ''; 
    }
    private get busy(): boolean {
        return this.loading
    }
    private set busy(value: boolean){
        this.loading = value
    }

    private setServerDefault(){
        if(this.group && this.group.attributes && !this.group.attributes.SERVER_SQL){
            this.group.attributes.SERVER_SQL = '';
        }
    }

    public async deleteContainerChacheUnigest() {
        const serial = this.group.attributes.SERIAL_NUMBER || ''
        
        if(!serial || serial.length == 0) return;
        
        const dataToSend  = `\"${serial}\"`; //{'contenedor':'Unigest_005015'};
        if(this.busy) return
        try {
            this.loading = true 
            this.$emit('loading', this.busy = true) //this.loading = true 
           apiUnigestService.setBaseUrl(this.uriApi);
           //const response = await ApiService.post('/admin/ReiniciarCacheContenedorAPI',dataToSend);
           await apiUnigestService.post('/admin/ReiniciarCacheDelSerial',dataToSend);
           notify('Cache borrada', Colors.Success);
        } catch (e) {
            const errorMessage = ('Error: ' + _.get(e, 'response.data.message', e.message));
            notify(errorMessage, Colors.Error);
            //throw new Error(_.get(e, 'response.data.message', e.message))
        }finally{
            this.$emit('loading', this.busy = false) //this.loading = true 
            this.loading = false;
        }
    }
    
}

export class ServerSQl
{
    public constructor(alias: string, serverName: string){
        this.alias = alias;
        this.serverName = serverName;
    }
    public alias = '';
    public serverName =  '';
} 
